import { AdminPermissions } from "../models/app";
import useAdminRole from "./useAdminRole";

const usePermissions = () => {
  const { adminRolesFetchAll } = useAdminRole("adminRoles", "adminRole");

  const adminPermissions: AdminPermissions = {
    // Guests
    see_guests: false,
    create_guest: false,
    edit_guest: false,
    delete_guest: false,

    // Dashboard and Reports
    dashboard: false,
    transactions_report: false,

    // Membership Cards
    view_card_codes: false,
    create_card_codes: false,
    delete_card_codes: false,

    // Settings
    settings_access: false,
    view_accounts: false,
    view_concepts: false,
    create_concept: false,
    assign_concept: false,

    view_tiers: false,
    create_tier: false,

    view_admin_groups: false,
    view_admin_roles: false,
    view_features: false,
    view_roles: false,

    // Admin Accesses
    admins_access: false,
    edit_admin: false,
    delete_admin: false,
  };

  const getAdminPermissions = async (props: {
    userGroup: any;
  }): Promise<AdminPermissions> => {
    const { userGroup } = props;
    if (userGroup && userGroup.length > 0) {
      let userRolesIds: any[] = [];
      for (let group of userGroup) {
        userRolesIds = userRolesIds.concat(group.roles);
      }

      const roles = await adminRolesFetchAll({ searchText: "" });
      const userRoles = roles.filter((r: any) =>
        userRolesIds.some((id: string) => r.id === id),
      );

      // @ts-ignore
      userRoles.forEach((r) => (adminPermissions[r.name] = true));
    }

    return adminPermissions;
  };

  return { getAdminPermissions };
};

export default usePermissions;
